<div class="p-4" *transloco="let t; read 'customer.saved_power_plants';">
  <div class="sm:w-1/2">
    <psc-input
      [formControl]="search"
      [label]="t('search')"></psc-input>
  </div>
  <div class="flex flex-wrap gap-4">
    <psc-loader *ngIf="loading" class="ml-8"></psc-loader>
    <ng-container *ngIf="!loading">
      <psc-power-plant-card
        @popInOut
        *ngFor="let powerPlant of shownPowerPlants"
        (plantDeleted)="getPowerPlants()"
        [powerPlant]="powerPlant"></psc-power-plant-card>
    </ng-container>
    <div class="[&>*]:text-3xl font-bold text-color-blue1">
      <div *ngIf="allPowerPlants?.length === 0">
        {{t('no_saved_plants')}}
      </div>
      <div *ngIf="shownPowerPlants?.length === 0 && allPowerPlants && allPowerPlants.length > 0">
        {{t('no_search_result')}}
      </div>
    </div>
  </div>

</div>
